// @flow
import {useCallback, useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useStores} from 'hooks/useStores';
import type {IObservable} from 'mobx';
import type {UIMemberType} from '@wellstone-solutions/common';

export const useDataLoader = ({
  initialFetch = true,
}: {
  initialFetch?: boolean,
} = {}): ({
  isLoading: boolean,
  data?: IObservable<UIMemberType>,
  fetchData: () => Promise<void>,
}) => {
  const {memberStore} = useStores();
  const {member: memberId} = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [currentMember, setCurrentMember] = useState(undefined);

  const fetchData = useCallback(async () => {
    setIsLoading(true);

    const member = await memberStore.getMember({
      id: memberId,
      forceFetch: true,
    });
    setCurrentMember(member);
    setIsLoading(false);
  }, [memberStore, memberId]);

  useEffect(() => {
    if (initialFetch) {
      fetchData();
    }
  }, [fetchData, initialFetch]);

  return {isLoading: isLoading, data: currentMember, fetchData};
};
